import { Theme } from 'morpheus-ui';
import { tv } from 'tailwind-variants';

const borderWidthKeys = Object.keys(Theme.borderWidth);
export const ContentWrapper = tv(
  {
    base: 'text-mono-color-black group w-full flex flex-row justify-between gap-sm bg-color-lightest rounded-md shadow-level-2 p-4 cursor-pointer overflow-visible',
    variants: {
      color: {
        interdisciplinar:
          'hover:bg-disciplina-interdisciplinar transition ease-in-out delay-100 hover:text-card-color-default',
        redacao:
          'hover:bg-disciplina-redacao transition ease-in-out delay-100 hover:text-card-color-default',
        literatura:
          'hover:bg-disciplina-literatura transition ease-in-out delay-100 hover:text-card-color-default',
        espanhol:
          'hover:bg-disciplina-espanhol transition ease-in-out delay-100 hover:text-card-color-default',
        ingles:
          'hover:bg-disciplina-ingles transition ease-in-out delay-100 hover:text-card-color-default',
        portugues:
          'hover:bg-disciplina-portugues transition ease-in-out delay-100 hover:text-card-color-default',
        gramatica:
          'hover:bg-disciplina-portugues transition ease-in-out delay-100 hover:text-card-color-default',
        sociologia:
          'hover:bg-disciplina-sociologia transition ease-in-out delay-100 hover:text-card-color-default',
        filosofia:
          'hover:bg-disciplina-filosofia transition ease-in-out delay-100 hover:text-card-color-default',
        geografia:
          'hover:bg-disciplina-geografia transition ease-in-out delay-100 hover:text-card-color-default',
        historia:
          'hover:bg-disciplina-historia transition ease-in-out delay-100 hover:text-card-color-default',
        matematica:
          'hover:bg-disciplina-matematica transition ease-in-out delay-100 hover:text-card-color-default',
        fisica:
          'hover:bg-disciplina-fisica transition ease-in-out delay-100 hover:text-card-color-default',
        quimica:
          'hover:bg-disciplina-quimica transition ease-in-out delay-100 hover:text-card-color-default',
        biologia:
          'hover:bg-disciplina-biologia transition ease-in-out delay-100 hover:text-card-color-default',
        atualidades:
          'hover:bg-disciplina-atualidades transition ease-in-out delay-100 hover:text-card-color-default',
        'bioquimica-superior':
          'hover:bg-disciplina-bioquimica-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'anatomia-superior':
          'hover:bg-disciplina-anatomia-humana-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'histologia-humana-superior':
          'hover:bg-disciplina-histologia-humana-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'fisiologia-superior':
          'hover:bg-disciplina-fisiologia-humana-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'genetica-superior':
          'hover:bg-disciplina-genetica-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'embriologia-superior':
          'hover:bg-disciplina-embriologia-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'imunologia-superior':
          'hover:bg-disciplina-imunologia-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'microbiologia-superior':
          'hover:bg-disciplina-microbiologia-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'parasitologia-superior':
          'hover:bg-disciplina-parasitologia-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'patologia-superior':
          'hover:bg-disciplina-patologia-superior transition ease-in-out delay-100 hover:text-card-color-default',
        'farmacologia-superior':
          'hover:bg-disciplina-farmacologia-superior transition ease-in-out delay-100 hover:text-card-color-default',
        default: '',
      },
      selected: {
        true: 'border-hairline border-brand-color-primary-pure',
      },
    },
  },
  {
    twMergeConfig: {
      theme: {
        borderWidth: borderWidthKeys,
      },
    },
  }
);

export const IconDone = tv({
  base: 'text-xxl filled',
  variants: {
    type: {
      done: 'text-feedback-color-success-pure',
      unseen: 'text-mono-color-medium',
      incorrect: 'text-feedback-color-error-pure',
    },
  },
});

export const IconFav = tv({
  base: 'p-0 filled',
  variants: {
    type: {
      favorite: 'text-brand-color-secondary-pure',
      notFavorite: 'text-mono-color-medium',
    },
  },
});

export const SubjectTag = tv(
  {
    base: 'flex max-w-[60%] flex-row items-center gap-sm px-2 text-mono-color-white',
    variants: {
      color: {
        interdisciplinar:
          'group-hover:text-disciplina-interdisciplinar transition ease-in-out delay-100 group-hover:bg-card-color-default',
        redacao:
          'group-hover:text-disciplina-redacao transition ease-in-out delay-100 group-hover:bg-card-color-default',
        literatura:
          'group-hover:text-disciplina-literatura transition ease-in-out delay-100 group-hover:bg-card-color-default',
        espanhol:
          'group-hover:text-disciplina-espanhol transition ease-in-out delay-100 group-hover:bg-card-color-default',
        ingles:
          'group-hover:text-disciplina-ingles transition ease-in-out delay-100 group-hover:bg-card-color-default',
        portugues:
          'group-hover:text-disciplina-portugues transition ease-in-out delay-100 group-hover:bg-card-color-default',
        gramatica:
          'group-hover:text-disciplina-portugues transition ease-in-out delay-100 group-hover:bg-card-color-default',
        sociologia:
          'group-hover:text-disciplina-sociologia transition ease-in-out delay-100 group-hover:bg-card-color-default',
        filosofia:
          'group-hover:text-disciplina-filosofia transition ease-in-out delay-100 group-hover:bg-card-color-default',
        geografia:
          'group-hover:text-disciplina-geografia transition ease-in-out delay-100 group-hover:bg-card-color-default',
        historia:
          'group-hover:text-disciplina-historia transition ease-in-out delay-100 group-hover:bg-card-color-default',
        matematica:
          'group-hover:text-disciplina-matematica transition ease-in-out delay-100 group-hover:bg-card-color-default',
        fisica:
          'group-hover:text-disciplina-fisica transition ease-in-out delay-100 group-hover:bg-card-color-default',
        quimica:
          'group-hover:text-disciplina-quimica transition ease-in-out delay-100 group-hover:bg-card-color-default',
        biologia:
          'group-hover:text-disciplina-biologia transition ease-in-out delay-100 group-hover:bg-card-color-default',
        atualidades:
          'group-hover:text-disciplina-atualidades transition ease-in-out delay-100 group-hover:bg-card-color-default',
        'bioquimica-superior':
          'group-hover:text-disciplina-bioquimica-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
        'anatomia-superior':
          'group-hover:text-disciplina-anatomia-humana-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
        'histologia-humana-superior':
          'group-hover:text-disciplina-histologia-humana-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
        'fisiologia-superior':
          'group-hover:text-disciplina-fisiologia-humana-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
        'genetica-superior':
          'group-hover:text-disciplina-genetica-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
        'embriologia-superior':
          'group-hover:text-disciplina-embriologia-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
        'imunologia-superior':
          'group-hover:text-disciplina-imunologia-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
        'microbiologia-superior':
          'group-hover:text-disciplina-microbiologia-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
        'parasitologia-superior':
          'group-hover:text-disciplina-parasitologia-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
        'patologia-superior':
          'group-hover:text-disciplina-patologia-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
        'farmacologia-superior':
          'group-hover:text-disciplina-farmacologia-superior transition ease-in-out delay-100 group-hover:bg-card-color-default',
        default: '',
      },
    },
  }
);
